// *************************************************
// リーグ一覧
// *************************************************
$(document).on('turbolinks:load', function () {
  // リーグ一覧のリーグカードをリンクにする
  document.querySelectorAll('.clickable-card').forEach(function(card) {
    card.addEventListener('click', function(event) {
      const url = this.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });

  // リーグ詳細の明細全体をリンクにする
  $('tr[data-href]').on('click', function() {
    window.location = $(this).data('href');
  });

  // イベント伝播停止の処理（リーグ一覧）
  document.querySelectorAll('[data-stop-propagation]:not([data-initialized])').forEach(function(element) {
    element.addEventListener('click', function(event) {
      event.stopPropagation();
    });
    element.setAttribute('data-initialized', 'true');
  });

});

// *************************************************
// リーグフォーム
// *************************************************
let leagueName, playTypeRadios, rule;  // 変数を宣言

function isTeamLeagueEdit() {
  var form = document.getElementById('league-form');
  return form && form.dataset.teamLeague === 'true';
}

// 作成フォームか（個人リーグの編集画面は toggleSubmitButton が決定ボタンを制御するため対象外にする）
function isLeagueCreateForm() {
  var form = document.getElementById('league-form');
  return form && form.dataset.createForm === 'true';
}

// 必須項目チェック（リーグ名・対戦形式・ルール）
function checkRequiredFields() {

  // turbolinks の復元や bfcache 復帰などでも安全に動くよう、要素参照は必要に応じて取得し直す
  leagueName ||= $('#league_name');
  rule ||= $('#league_rule_id');
  playTypeRadios ||= $('input[name="league[play_type]"]');

  if (!leagueName.length || !playTypeRadios.length || !rule.length) return;
  if (!isLeagueCreateForm() && !isTeamLeagueEdit()) return;

  const leagueNameValue = leagueName.val()?.trim()?.length || 0;
  // ラジオボタンは選択されているかどうかをチェック
  const playTypeValue = $('input[name="league[play_type]"]:checked').length > 0 ? 1 : 0;
  const ruleValue = rule.val()?.trim()?.length || 0;

  const submitButton = document.querySelector('#league_create_btn');
  if (!submitButton) return;

  if (leagueNameValue > 0 && playTypeValue > 0 && ruleValue > 0) {
    submitButton.disabled = false;
    submitButton.classList.remove('inactive');
  } else {
    submitButton.disabled = true;
    submitButton.classList.add('inactive');
  }
}

$(document).on('turbolinks:load', function () {
  // DOMが読み込まれた後に要素を取得
  leagueName = $('#league_name');
  playTypeRadios = $('input[name="league[play_type]"]');
  rule = $('#league_rule_id');
  if (!leagueName.length || !playTypeRadios.length || !rule.length) return;
  if (!isLeagueCreateForm() && !isTeamLeagueEdit()) return;

  // イベントリスナーを設定
  leagueName.on('input', checkRequiredFields);
  playTypeRadios.on('change', checkRequiredFields);
  rule.on('change', checkRequiredFields);

  // 初期状態のチェック
  checkRequiredFields();
});

// ルール登録リンク押下時、入力中のリーグ名を sessionStorage へ保存する
// （ルール登録→戻る、の往復でリーグ名を復元するため）
$(document).on('click', '.js-rule-link', function() {
  const input = document.querySelector('#league_name');
  if (!input) return;

  const name = (input.value || '').trim();
  window.sessionStorage.setItem('league_name', name);
});

// ページ表示（Turbolinks 含む）時に sessionStorage のリーグ名を復元する
$(document).on('turbolinks:load', function () {
  const input = document.querySelector('#league_name');
  if (!input) return;

  const leagueName = window.sessionStorage.getItem('league_name');
  if (!leagueName) return;

  input.value = leagueName;
  window.sessionStorage.removeItem('league_name');
  // 文字数カウンター（components/form_counter.js）を復元した値に追従させる
  input.dispatchEvent(new Event('input', { bubbles: true }));

  // 値を復元した後に必須チェックを再実行し、ボタン状態を正しく同期する
  checkRequiredFields();
});

// play_typeが四麻のときプレイヤー数は4人以上である場合のみ登録・更新ボタンを有効化
// 現在のパスがleagues/:id/edit の場合のみ実行する
$(document).on('turbolinks:load', function () {
  currentPath = window.location.pathname;
  if (currentPath.match(/\/leagues\/\d+\/edit/)) {
    const playTypeRadios = document.querySelectorAll('input[name="league[play_type]"]');
    const submitButton = document.querySelector('#league_create_btn');

    // プレイヤー数が4人以上の場合のみ登録・更新ボタンを有効化
    function toggleSubmitButton() {
      // チームリーグ編集時はプレイヤーセクションがないためスキップ
      if (isTeamLeagueEdit()) {
        submitButton.disabled = false;
        submitButton.classList.remove('inactive');
        return;
      }

      const checkedRadio = document.querySelector('input[name="league[play_type]"]:checked');
      const playType = checkedRadio ? parseInt(checkedRadio.value, 10) : 4;
      const playerNum = document.querySelectorAll('#league-form .chip').length;

      if (playType === 4 && playerNum < 4) {
        submitButton.disabled = true;
        submitButton.classList.add('inactive');// ボタンを薄い色にする
      } else {
        submitButton.disabled = false;
        submitButton.classList.remove('inactive');// ボタンの色を元に戻す
      }
    }

    playTypeRadios.forEach(function(radio) {
      radio.addEventListener('change', toggleSubmitButton);
    });

    // 初期状態のチェック
    toggleSubmitButton();
  }
});

// *************************************************
// リーグプレイヤー選択
// *************************************************
// <league記録プレイヤー選択フォーム>
window.addEventListener('load', function() {
  var currentPath = window.location.pathname;
  var match = currentPath.match(/\/leagues\/(\d+)\/select_players\/new/);

  if (!match) return;

  var checkboxes = document.querySelectorAll('.league-player-card input[type="checkbox"]');
  var playType = parseInt(document.querySelector('.play-type-hidden').textContent);
  var selectBtn = $('#league_players_select_btn');

  // プレイヤー決定ボタンの状態を更新
  function updateButtonState(checkedCount) {
    if (checkedCount === playType) {
      selectBtn.prop('disabled', false).removeClass('inactive');
    } else {
      selectBtn.prop('disabled', true).addClass('inactive');
    }
    $('.player-selected-count').text(checkedCount);
  }

  var loadCheckedCount = Array.from(checkboxes).filter(i => i.checked).length; // ページ読み込み時のチェック数
  updateButtonState(loadCheckedCount);

  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      var checkedCount = Array.from(checkboxes).filter(i => i.checked).length; // チェック数
      var max = document.querySelector('.league-players-list').dataset.max;
      if (checkedCount > max) {
        alert(window.Janreco.pluralize($('.league-players-list').data('selectionLimitMessage'), Number(max)));
        this.checked = false;
        checkedCount = checkedCount - 1;
      }
      updateButtonState(checkedCount);
    });
  });
});

// *************************************************
// リーグ詳細画面
// *************************************************
// 成績一覧テーブルの固定列の幅を調整
$(document).on('turbolinks:load', function() {
  if (!window.location.pathname.includes('/leagues')) return;

  updateStickyColumns();
  $(window).on('resize.stickyColumns', updateStickyColumns);
});

$(document).on('turbolinks:before-cache', function() {
  $(window).off('resize.stickyColumns');
});

function updateStickyColumns() {
  var element = document.querySelector('.fixed-01');
  var firstColumnWidth = element ? element.offsetWidth : 0;
  var secondColumns = document.querySelectorAll('.fixed-02');
  secondColumns.forEach(function(column) {
    column.style.left = firstColumnWidth + 'px';
  });
}
